module.exports = __webpack_public_path__ + "img/logo.1152cfa4.png";